"use client";

import { memo } from "react";
import {
  useA2UIComponent,
  type A2UIComponentProps,
  type Types,
} from "@a2ui/react";
import { resolveEnum, renderChildren } from "./utils";

const JUSTIFY: Record<string, string> = {
  start: "justify-start",
  center: "justify-center",
  end: "justify-end",
  spaceBetween: "justify-between",
  spaceAround: "justify-around",
  spaceEvenly: "justify-evenly",
};

const ALIGN: Record<string, string> = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch",
};

export const BeeOSColumn = memo(function BeeOSColumn({
  node,
  surfaceId,
}: A2UIComponentProps<Types.ColumnNode>) {
  useA2UIComponent(node, surfaceId);
  const props = node.properties;
  const alignment = resolveEnum(props.alignment, "stretch");
  const distribution = resolveEnum(props.distribution, "start");
  const children = Array.isArray(props.children) ? props.children : [];

  const hostStyle: React.CSSProperties =
    node.weight !== undefined
      ? ({ "--weight": node.weight } as React.CSSProperties)
      : {};

  return (
    <div
      className="a2ui-column"
      data-alignment={alignment}
      data-distribution={distribution}
      style={hostStyle}
    >
      <div
        className={`flex flex-col gap-2 min-w-full h-full ${JUSTIFY[distribution] ?? "justify-start"} ${ALIGN[alignment] ?? "items-stretch"}`}
      >
        {renderChildren(children, surfaceId)}
      </div>
    </div>
  );
});
